export var FETCH_MATCH_RESULTS = 'FETCH_MATCH_RESULTS';
export var CLEAR_MATCH_RESULTS = 'CLEAR_MATCH_RESULTS';
export var SUCCESS_FETCH_MATCH_RESULTS = 'SUCCESS_FETCH_MATCH_RESULTS';
export var FAILURE_FETCH_MATCH_RESULTS = 'FAILURE_FETCH_MATCH_RESULTS';



// WEBPACK FOOTER //
// ./src/actions/matchResults.js